import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { QuestionnaireService } from "../services/questionnaire.service";
import { LeadService } from "../services/lead.service";
import { Router } from '@angular/router';
import { HelpDialogComponent } from "../help-dialog/help-dialog.component";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { RestartDialogComponent } from "../restart-dialog/restart-dialog.component";

@Component({
	selector: 'app-mashkanta-questioner',
	templateUrl: './mashkanta-questioner.component.html',
	styleUrls: ['./mashkanta-questioner.component.scss']
})
export class MashkantaQuestionerComponent implements OnInit {
	modalRef;
	showScrollHint = false;

	constructor(
		private questionnaireService: QuestionnaireService,
		private leadService: LeadService,
    private router: Router,
		private modalService: NgbModal,
		private changeDetectorRef:ChangeDetectorRef
  ) { }
  



	ngOnInit() {
		this.questionnaireService.scrollHintVisibleChange.subscribe(show=>{
				this.showScrollHint=show;
				//console.log("1)************************************",this.showScrollHint);
				if(show){
					this.changeDetectorRef.detectChanges();
				}
			},error=>{}
		);

		//this.showScrollHint=true;
	}
	
	test1(){
		console.log(">>>>   ",this.showScrollHint);
	}
  
  openHelpDialog() {
    this.modalRef = this.modalService.open(HelpDialogComponent);
    // .result.then((result) => {
    //   this.closeResult = `Closed with: ${result}`;
    // }, (reason) => {
    //   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    // });
  }

	// restartClick() {
	// 	console.log(">>> restartClick()");
	// 	this.modalRef = this.modalService.open(RestartDialogComponent).result.then((result) => {
	// 				this.questionnaireService.reset("1");
	// 		this.router.navigate([""]).then(
	// 		res=>{
	// 			this.router.navigate(["questionnaire", "user-details", "1"]);
	// 		}
	// 	);
  //   });


	
	//}
	// sendFormTest() { //TODO: remove
	// 	this.leadService.submitMashForm().subscribe(
	// 		data => {
	// 			console.log("send lead sucseed");
	// 		});
	// }
}



// WEBPACK FOOTER //
// ./src/app/mashkanta-questioner/mashkanta-questioner.component.ts